import { createRouter, createWebHashHistory } from 'vue-router'
import { recoverFromChunkLoadError } from '@/utils/chunkLoadRecovery'
import { forceHideLoading } from '@/api/httpRequest'
import store from '@/store'
import { hasRoutePermission, isSystemSuperAdmin } from './authGuard'
const router = createRouter({
  history: createWebHashHistory(), // 这里必须是history模式 其他模式会导致后面打包生成的静态文件内容都是一样的，不能起到预渲染的作用
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/Login.vue')
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('../views/HomeView.vue'),
      children: [
        {
          path: 'CompanyManage',
          name: 'CompanyManage', //公司管理
          component: () => import('../views/superAdmin/CompanyManage.vue'),
          meta: { keepAlive: true, title: '公司管理' }
        },
        {
          path: 'MenuManage',
          name: 'MenuManage', //菜单管理
          component: () => import('../views/superAdmin/MenuManage.vue'),
          meta: { keepAlive: true, title: '菜单管理' }
        },
        {
          path: 'RoleManage',
          name: 'RoleManage', //角色管理
          component: () => import('../views/system/RoleManage.vue'),
          meta: { keepAlive: true, title: '角色管理' }
        },
        {
          path: 'CompanyRoleTemplate',
          name: 'CompanyRoleTemplate', //公司角色模板设置
          component: () => import('../views/system/CompanyRoleTemplate.vue'),
          meta: { keepAlive: true, title: '公司角色模板设置', systemSuperAdminOnly: true }
        }, {
          path: 'UserManage',
          name: 'UserManage', //用户管理
          component: () => import('../views/system/UserManage.vue'),
          meta: { keepAlive: true, title: '用户管理' }
        },
        {
          path: 'DataDictionary',
          name: 'DataDictionary', //数据字典
          component: () => import('../views/superAdmin/DataDictionary.vue'),
          meta: { keepAlive: true, title: '数据字典' }
        },{
          path: 'DictionaryDetail',
          name: 'DictionaryDetail', //数据字典详情
          component: () => import('../views/superAdmin/DictionaryDetail.vue'),
          meta: { keepAlive: true, title: '字典详情', permissionRoute: 'DataDictionary' }
        },{
          path: 'VersionList',
          name: 'VersionList', //版本列表
          component: () => import('../views/superAdmin/VersionList.vue'),
          meta: { keepAlive: true, title: '版本管理' }
        },{
          path: 'TestPage',
          name: 'TestPage', //测试页面
          component: () => import('../views/TestPage.vue'),
          meta: { keepAlive: true, title: '测试页面' }
        },{
          path: 'ProjectList',
          name: 'ProjectList', //订单汇总
          component: () => import('../views/Project/ProjectList.vue'),
          meta: { keepAlive: true, title: '订单汇总' }
        },{
          path: 'ProjectBoard',
          name: 'ProjectBoard', //进行中订单
          component: () => import('../views/Project/ProjectBoard.vue'),
          meta: { keepAlive: true, title: '进行中订单' }
        },{
          path: 'ProjectDetail',
          name: 'ProjectDetail', //订单详情
          component: () => import('../views/Project/ProjectDetail.vue'),
          meta: { keepAlive: true, title: '订单详情', permissionRoute: 'ProjectList' }
        },{
          path: 'AddProject',
          name: 'AddProject', //添加订单
          component: () => import('../views/Project/AddProject.vue'),
          meta: { keepAlive: true, title: '编辑订单', permissionRoute: 'ProjectList' }
        },{
          path: 'Operationlog',
          name: 'Operationlog', //操作日志
          component: () => import('../views/system/Operationlog.vue'),
          meta: { keepAlive: true, title: '操作日志' }
        },{
          path: 'SupplierTier',
          name: 'SupplierTier', //供应商等级
          component: () => import('../views/Setting/SupplierTier.vue'),
          meta: { keepAlive: true, title: '供应商等级' }
        },{
          path: 'SupplierList',
          name: 'SupplierList', //供应商管理
          component: () => import('../views/Supply/SupplierList.vue'),
          meta: { keepAlive: true, title: '供应商列表' }
        },{
          path: 'SupplierDetail',
          name: 'SupplierDetail', //供应商档案
          component: () => import('../views/Supply/SupplierDetail.vue'),
          meta: { keepAlive: true, title: '供应商档案', permissionRoute: 'SupplierList' }
        },{
          path: 'MessageList',
          name: 'MessageList', //消息列表
          component: () => import('../views/Task/MessageList.vue'),
          meta: { keepAlive: true, title: '消息列表' }
        },{
          path: 'WorkReportList',
          name: 'WorkReportList', //日报周报列表
          component: () => import('../views/Task/WorkReportList.vue'),
          meta: { keepAlive: true, title: '日报周报' }
        },{
          path: 'WorkReportDeliveryDetail',
          name: 'WorkReportDeliveryDetail', //日报周报投递详情
          component: () => import('../views/Task/WorkReportDeliveryDetail.vue'),
          meta: { keepAlive: true, title: '报表详情', permissionRoute: 'WorkReportList' }
        },{
          path: 'Workbench',
          name: 'Workbench', //工作台
          component: () => import(/* webpackPrefetch: true */ '../views/Task/WorkbenchDashboard.vue'),
          meta: { keepAlive: true, title: 'AI工作台' }
        },
        {
          path: 'ProductSetting',
          name: 'ProductSetting', //产品设置
          component: () => import('../views/Setting/Product/ProductSetting.vue'),
          meta: { keepAlive: true, title: '产品设置' }
        },{
          path: 'ProductList',
          name: 'ProductList', //产品列表
          component: () => import('../views/Product/ProductList.vue'),
          meta: { keepAlive: true, title: '产品列表' }
        },{
          path: 'ProductDetail',
          name: 'ProductDetail', //产品详情
          component: () => import('../views/Product/ProductDetail.vue'),
          meta: { keepAlive: true, title: '产品档案', permissionRoute: 'ProductList' }
        },{
          path: 'CustomerSetting',
          name: 'CustomerSetting', //客户设置
          component: () => import('../views/Setting/Customer/CustomerSetting.vue'),
          meta: { keepAlive: true, title: '客户设置' }
        },{
          path: 'CustomerBoard',
          name: 'CustomerBoard', //客户管家
          component: () => import('../views/Customer/CustomerBoard.vue'),
          meta: { keepAlive: true, title: '客户管家' }
        },{
          path: 'CustomerList',
          name: 'CustomerList', //客户列表
          component: () => import(/* webpackPrefetch: true */ '../views/Customer/CustomerList.vue'),
          meta: { keepAlive: true, title: '客户列表' }
        },{
          path: 'CustomerPublicPool',
          name: 'CustomerPublicPool', //公海客户
          component: () => import('../views/Customer/CustomerList.vue'),
          meta: { keepAlive: true, title: '公海客户' }
        },{
          path: 'CustomerDetail',
          name: 'CustomerDetail', //客户详情
          component: () => import('../views/Customer/CustomerDetail.vue'),
          meta: { keepAlive: true, title: '客户档案', permissionRoute: 'CustomerList' }
        },{
          path: 'AiPrompt',
          name: 'AiPrompt', //AI提示词管理
          component: () => import('../views/superAdmin/AiPrompt.vue'),
          meta: { keepAlive: true, title: 'AI提示词管理' }
        },{
          path: 'AiLog',
          name: 'AiLog', //AI调用日志
          component: () => import('../views/superAdmin/AiLog.vue'),
          meta: { keepAlive: true, title: 'AI调用日志' }
        },{
          path: 'AiUsageAnalysis',
          name: 'AiUsageAnalysis',
          component: () => import('../views/superAdmin/AiUsageAnalysis.vue'),
          meta: { keepAlive: true, title: 'AI用量分析' }
        },{
          path: 'AiKnowledgeBase',
          name: 'AiKnowledgeBase',
          component: () => import('../views/system/AiSetting/AiSetting.vue'),
          meta: { keepAlive: true, title: 'AI设置' }
        },{
          path: 'EnterpriseIntelligenceHub',
          name: 'EnterpriseIntelligenceHub',
          component: () => import('../views/system/AiSetting/EnterpriseIntelligenceHub.vue'),
          meta: { keepAlive: true, title: '企业智能中枢' }
        },{
          path: 'AcquisitionFindCompany',
          name: 'AcquisitionFindCompany',
          component: () => import('../views/Acquisition/FindCompany.vue'),
          meta: { keepAlive: true, title: '找公司' }
        },{
          path: 'AcquisitionScoringTemplates',
          name: 'AcquisitionScoringTemplates',
          component: () => import('../views/Acquisition/ScoringTemplates.vue'),
          meta: { keepAlive: true, title: '评分模板' }
        },{
          path: 'AcquisitionTasks',
          name: 'AcquisitionTasks',
          component: () => import('../views/Acquisition/Tasks.vue'),
          meta: { keepAlive: true, title: '获客任务' }
        },{
          path: 'AcquisitionCompanyPool',
          name: 'AcquisitionCompanyPool',
          component: () => import('../views/Acquisition/CompanyPool.vue'),
          meta: { keepAlive: true, title: '公司池' }
        },{
          path: 'AiAgentManager',
          name: 'AiAgentManager',
          component: () => import('../views/Ai/AgentManager.vue'),
          meta: { keepAlive: true, title: '智能体管理', permissionRoute: 'Email' }
        },{
          path: 'AiAgentCreate',
          name: 'AiAgentCreate',
          component: () => import('../views/Ai/AgentManager.vue'),
          props: { initialCreate: true },
          meta: { keepAlive: true, title: '创建智能体', permissionRoute: 'Email' }
        },{
          path: 'ClueList',
          name: 'ClueList', //线索池
          component: () => import(/* webpackPrefetch: true */ '../views/Clue/ClueList.vue'),
          meta: { keepAlive: true, title: '线索池' }
        },{
          path: 'IntentionLeadList',
          name: 'IntentionLeadList', //意向线索菜单(后端菜单下发)
          component: () => import('../views/Clue/IntentionLeadList.vue'),
          meta: { keepAlive: true, title: '意向线索' }
        },{
          path: 'Email',
          name: 'Email', //邮件
          component: () => import(/* webpackPrefetch: true */ '../views/Email/Email.vue'),
          meta: { keepAlive: true, title: '邮件' }
        },{
          path: 'EmailSetting',
          name: 'EmailSetting', //邮件设置
          component: () => import('../views/Email/Setting/EmailSetting.vue'),
          meta: { keepAlive: true, title: '邮件设置', permissionRoute: 'Email' }
        },{
          path: 'Write',
          name: 'Write', //写邮件
          component: () => import('../views/Email/Template/Write.vue'),
          meta: { keepAlive: true, title: '写邮件', permissionRoute: 'Email' }
        },{
          path: 'EmailTemplates',
          name: 'EmailTemplates', //邮件模板
          component: () => import('../views/Clue/EmailTemplates.vue'),
          meta: { keepAlive: true, title: '邮件模版' }
        },{
          path: 'DevelopmentPlan',
          name: 'DevelopmentPlan', //邮件方案
          component: () => import('../views/Clue/DevelopmentPlan.vue'),
          meta: { keepAlive: true, title: '邮件方案' }
        },{
          path: 'ClueTaskList',
          name: 'ClueTaskList', //任务列表
          component: () => import('../views/Clue/ClueTaskList.vue'),
          meta: { keepAlive: true, title: '线索开发任务' }
        },{
          path: 'ClueTaskListProxy',
          name: 'ClueTaskListProxy', //代发线索任务（邮件代发版本）
          component: () => import(/* webpackPrefetch: true */ '../views/Clue/ClueTaskListProxy.vue'),
          meta: { keepAlive: true, title: '代发线索任务' }
        },{
          path: 'CustomerMarketingTask',
          name: 'CustomerMarketingTask', //客户营销代发任务
          component: () => import('../views/Clue/CustomerMarketingTask.vue'),
          meta: { keepAlive: true, title: '客户营销代发' }
        },{
          path: 'ClueStatistics',
          name: 'ClueStatistics', //线索统计
          component: () => import('../views/Clue/ClueStatistics.vue'),
          meta: { keepAlive: true, title: '线索统计看板' }
        },{
          path: 'ProxyLeadProcess',
          name: 'ProxyLeadProcess', //代发线索处理
          component: () => import('../views/Clue/ProxyLeadProcess.vue'),
          meta: { keepAlive: true, title: '代发线索处理' }
        },{
          path: 'AddTask',
          name: 'AddTask', //新增任务
          component: () => import('../views/Clue/AddTask.vue'),
          meta: { keepAlive: true, title: '新建开发任务', permissionRoute: 'ClueTaskList' }
        },{
          path: 'AddTaskProxy',
          name: 'AddTaskProxy', //代发版新增任务（邮件代发版本）
          component: () => import('../views/Clue/AddTaskProxy.vue'),
          meta: { keepAlive: true, title: '新建开发任务', permissionRoute: 'ClueTaskListProxy' }
        },{
          path: 'CustomerMarketingAddTask',
          name: 'CustomerMarketingAddTask', //客户营销代发版新增任务
          component: () => import('../views/Clue/CustomerMarketingAddTask.vue'),
          meta: { keepAlive: true, title: '新建营销任务', permissionRoute: 'CustomerMarketingTask' }
        },{
          path: 'TaskDetailProxy',
          name: 'TaskDetailProxy', //代发线索任务详情（任务概览），页签标题随 query.title 展示任务名称，不参与 keep-alive 缓存
          component: () => import('../views/Clue/TaskDetailProxy.vue'),
          meta: { keepAlive: false, title: '任务详情', permissionRoute: 'ClueTaskListProxy' }
        },{
          path: 'CustomerMarketingTaskDetail',
          name: 'CustomerMarketingTaskDetail', //客户营销代发任务详情（任务概览），页签标题随 query.title 展示任务名称，不参与 keep-alive 缓存
          component: () => import('../views/Clue/CustomerMarketingTaskDetail.vue'),
          meta: { keepAlive: false, title: '任务详情', permissionRoute: 'CustomerMarketingTask' }
        },{
          path: 'TimingEmail',
          name: 'TimingEmail', //定时邮件
          component: () => import('../views/Email/Template/TimingEmail.vue'),
          meta: { keepAlive: true, title: '定时邮件' }
        },{
          path: 'TaskList',
          name: 'TaskList', //任务列表
          component: () => import('../views/Task/TaskList.vue'),
          meta: { keepAlive: true, title: '任务管理' }
        },{
          path: 'UnitList',
          name: 'UnitList', //单位列表
          component: () => import('../views/system/UnitList.vue'),
          meta: { keepAlive: true, title: '计量单位管理' }
        },{
          path: 'OrderCompany',
          name: 'OrderCompany', //订单公司
          component: () => import('../views/system/OrderCompany.vue'),
          meta: { keepAlive: true, title: '多公司管理' }
        },{
          path: 'AutoGetCompany',
          name: 'AutoGetCompany', //自动化公司判断记录
          component: () => import('../views/system/AutoGetCompany.vue'),
          meta: { keepAlive: true, title: '自动化公司判断记录' }
        },{
          path: 'SystemManage',
          name: 'SystemManage', //系统管理
          component: () => import('../views/system/SystemManage/SystemManage.vue'),
          meta: { keepAlive: true, title: '系统管理' }
        },{
          path: 'OrderSetting',
          name: 'OrderSetting', //单据设置
          component: () => import('../views/system/OrderSetting/OrderSetting.vue'),
          meta: { keepAlive: true, title: '单据设置' }
        },{
          path: 'InquiryList',
          name: 'InquiryList', //询盘列表
          component: () => import(/* webpackPrefetch: true */ '../views/Inquiry/InquiryList.vue'),
          meta: { keepAlive: true, title: '询盘列表' }
        },{
          path: 'InquiryDetail',
          name: 'InquiryDetail', //询盘详情
          component: () => import('../views/Inquiry/InquiryDetail.vue'),
          meta: { keepAlive: true, title: '询盘详情', permissionRoute: 'InquiryList' }
        },{
          path: 'OngoingInquiry',
          name: 'OngoingInquiry',
          component: () => import('../views/Inquiry/OngoingInquiry.vue'),
          meta: { keepAlive: true, title: '进行中询盘' }
        },{
          path: 'InquirySetting',
          name: 'InquirySetting', //询盘设置
          component: () => import('../views/Setting/Inquiry/InquirySetting.vue'),
          meta: { keepAlive: true, title: '询盘设置' }
        },{
          path: 'InquiryStatistics',
          name: 'InquiryStatistics', //询价单统计
          component: () => import('../views/Inquiry/InquiryStatistics.vue'),
          meta: { keepAlive: true, title: '询盘统计' }
        },{
          path: 'InquiryMultiDimension',
          name: 'InquiryMultiDimension', //询盘多维度统计
          component: () => import('../views/Inquiry/InquiryMultiDimension.vue'),
          meta: { keepAlive: true, title: '询盘多维度统计', permissionRoute: 'InquiryStatistics' }
        },{
          path: 'QuotationRequest',
          name: 'QuotationRequest', //报价需求单
          component: () => import('../views/Project/Order/QuotationRequest.vue'),
          meta: { keepAlive: true, title: '报价需求单' }
        },{
          path: 'SupplierQuotation',
          name: 'SupplierQuotation', //供应商报价单
          component: () => import('../views/Project/Order/SupplierQuotation.vue'),
          meta: { keepAlive: true, title: '供应商报价单' }
        },{
          path: 'InternalQuotation',
          name: 'InternalQuotation', //内部报价单
          component: () => import('../views/Project/Order/InternalQuotation.vue'),
          meta: { keepAlive: true, title: '内部报价单' }
        },{
          path: 'QuotationOrder',
          name: 'QuotationOrder', //报价单
          component: () => import('../views/Project/Order/QuotationOrder.vue'),
          meta: { keepAlive: true, title: '报价单' }
        },{
          path: 'editQuotationOrder',
          name: 'editQuotationOrder', //报价单
          component: () => import('../views/Project/Order/editOrder/editQuotationOrder.vue'),
          meta: { keepAlive: true, title: '编辑报价单', permissionRoute: 'QuotationOrder' }
        },{
          path: 'editQuotationOrderTest',
          name: 'editQuotationOrderTest', //兼容旧入口
          redirect: to => ({ name: 'editQuotationOrder', query: to.query })
        },{
          path: 'PO',
          name: 'PO', //采购订单
          component: () => import('../views/Project/Order/PO.vue'),
          meta: { keepAlive: true, title: 'PO' }
        },{
          path: 'ProcurementRequirements',
          name: 'ProcurementRequirements', //采购需求单
          component: () => import('../views/Project/Order/ProcurementRequirements.vue'),
          meta: { keepAlive: true, title: '采购需求单' }
        },{
          path: 'ProcurementContract',
          name: 'ProcurementContract', //采购合同
          component: () => import('../views/Project/Order/ProcurementContract.vue'),
          meta: { keepAlive: true, title: '采购合同' }
        },{
          path: 'editProcurementContract',
          name: 'editProcurementContract', //编辑采购合同
          component: () => import('../views/Project/Order/editOrder/editProcurementContract.vue'),
          meta: { keepAlive: true, title: '编辑采购合同', permissionRoute: 'ProcurementContract' }
        },{
          path: 'editProcurementContractTest',
          name: 'editProcurementContractTest', //兼容旧入口
          redirect: to => ({ name: 'editProcurementContract', query: to.query })
        },{
          path: 'ProcurementOrder',
          name: 'ProcurementOrder', //采购订单跟踪
          component: () => import('../views/Project/Order/ProcurementOrder.vue'),
          meta: { keepAlive: true, title: '采购订单跟踪' }
        },{
          path: 'Invoice',
          name: 'Invoice', //发票
          component: () => import('../views/Project/Order/Invoice.vue'),
          meta: { keepAlive: true, title: '发票' }
        },{
          path: 'editInvoice',
          name: 'editInvoice', //编辑发票
          component: () => import('../views/Project/Order/editOrder/editInvoice.vue'),
          meta: { keepAlive: true, title: '编辑发票', permissionRoute: 'Invoice' }
        },{
          path: 'editInvoiceTest',
          name: 'editInvoiceTest', //兼容旧入口
          redirect: to => ({ name: 'editInvoice', query: to.query })
        },{
          path: 'PackingList',
          name: 'PackingList', //装箱单
          component: () => import('../views/Project/Order/PackingList.vue'),
          meta: { keepAlive: true, title: '装箱单' }
        },{
          path: 'editPackingList',
          name: 'editPackingList', //编辑装箱单
          component: () => import('../views/Project/Order/editOrder/editPackingList.vue'),
          meta: { keepAlive: true, title: '编辑装箱单', permissionRoute: 'PackingList' }
        },{
          path: 'editPackingListTest',
          name: 'editPackingListTest', //兼容旧入口
          redirect: to => ({ name: 'editPackingList', query: to.query })
        },
        {
          path: 'EmailTemplates2',
          name: 'EmailTemplates2', //客户邮件模板
          component: () => import('../views/Customer/Task/EmailTemplates2.vue'),
          meta: { keepAlive: true, title: '客户邮件模板' }
        },
        {
          path: 'DevelopmentPlan2',
          name: 'DevelopmentPlan2', //客户任务方案
          component: () => import('../views/Customer/Task/DevelopmentPlan2.vue'),
          meta: { keepAlive: true, title: '客户任务方案' }
        },{
          path: 'ClueTaskList2',
          name: 'ClueTaskList2', //客户营销任务
          component: () => import('../views/Customer/Task/ClueTaskList2.vue'),
          meta: { keepAlive: true, title: '客户营销任务' }
        },{
          path: 'AddTask2',
          name: 'AddTask2', //客户任务制定
          component: () => import('../views/Customer/Task/AddTask2.vue'),
          meta: { keepAlive: true, title: '客户任务制定', permissionRoute: 'ClueTaskList2' }
        },{
          path: 'TemplateInstruction',
          name: 'TemplateInstruction', //模板制作说明
          component: () => import('../views/system/TemplateInstruction.vue'),
          meta: { keepAlive: true, title: '模板制作说明', permissionRoute: 'OrderSetting' }
        },
        {
          path: 'WhatsApp',
          name: 'WhatsApp', //WhatsApp
          component: () => import('../views/WhatsApp/WhatsApp.vue'),
          meta: { keepAlive: true, title: 'WhatsApp' }
        },
      ]
    },
    {
      path: '/richTextPage',
      name: 'RichTextPage',
      component: () => import('../test/richTextPage.vue')
    },
    {
      path: '/403',
      name: 'Forbidden',
      component: () => import('../views/Forbidden.vue')
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('../test/test.vue') 
    },
    {
      path: '/EmailPrint',
      name: 'EmailPrint',
      component: () => import('../views/Email/Template/EmailPrint.vue'),
      meta: { permissionRoute: 'Email' }
    },
    {
      path: '/test2',
      name: 'test2',
      component: () => import('../test/test2.vue') 
    },{
      path: '/test3',
      name: 'test3',
      component: () => import('../test/test3.vue') 
    },{
      path: '/test4',
      name: 'test4',
      component: () => import('../test/test4.vue') 
    },{
      path: '/test5',
      name: 'test5',
      component: () => import('../test/test5.vue') 
    },{
      path: '/test6',
      name: 'test6',
      component: () => import('../test/test6.vue') 
    },{
      path: '/test7',
      name: 'test7',
      component: () => import('../test/test7.vue') 
    },{
      path: '/test8',
      name: 'test8',
      component: () => import('../test/test8.vue') 
    },{
      path: '/testUi',
      name: 'testUi',
      component: () => import('../test/testUi.vue') 
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('../views/NotFound.vue'),
      meta: { isNotFound: true }
    },
  ]
})

router.onError((error, to) => {
  recoverFromChunkLoadError(error, {
    target: to?.fullPath || window.location.href
  })
})

const publicRouteNames = new Set(['Login'])
const authExemptRouteNames = new Set(['Forbidden'])
// 全员入口：所有已登录用户均可进入，不依赖后台菜单树。
// “客户管家”和“进行中订单”已调整为普通菜单，访问权限跟随后台菜单配置。
const authenticatedRouteNames = new Set(['Workbench', 'WhatsApp', 'WorkReportList', 'MessageList', 'AcquisitionScoringTemplates'])
const LOGIN_PAGE_TITLE = '登录'
const SYSTEM_PAGE_TITLE = '兴泰科ai外贸'

router.beforeEach((to) => {
  // 路由切换时强制清理残留的全局 loading，防止上一页请求未完成时遮罩延续到新页面
  forceHideLoading()

  // 未注册的地址优先进入 404，不应被当作权限不足处理。
  if (to.meta?.isNotFound) {
    return true
  }

  if (publicRouteNames.has(String(to.name || ''))) {
    return true
  }

  if (!store.state.token) {
    return {
      name: 'Login',
      query: { redirect: to.fullPath }
    }
  }

  if (authExemptRouteNames.has(String(to.name || ''))) {
    return true
  }

  if (authenticatedRouteNames.has(String(to.name || ''))) {
    return true
  }

  if (to.meta?.systemSuperAdminOnly && !isSystemSuperAdmin()) {
    return {
      name: 'Forbidden',
      query: { from: to.fullPath }
    }
  }

  if (!hasRoutePermission(to)) {
    return {
      name: 'Forbidden',
      query: { from: to.fullPath }
    }
  }

  return true
})

router.afterEach((to) => {
  if (publicRouteNames.has(String(to.name || ''))) {
    document.title = LOGIN_PAGE_TITLE
  } else {
    const pageTitle = to.meta?.title
    document.title = pageTitle ? `${pageTitle} - ${SYSTEM_PAGE_TITLE}` : SYSTEM_PAGE_TITLE
  }
})

export default router
